jQuery.event.special.touchstart = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchstart", handle, { passive: false });
    } else {
      this.addEventListener("touchstart", handle, { passive: true });
    }
  },
};

jQuery.event.special.touchmove = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchmove", handle, { passive: false });
    } else {
      this.addEventListener("touchmove", handle, { passive: true });
    }
  },
};

$(".hamburger").on("click", function () {
  $(".navigation-wrapper").toggleClass("navi-open");
  $("body").toggleClass("navi-open");
});

$(".close-navi").on("click", function () {
  $(".navigation-wrapper").removeClass("navi-open");
  $(".dropdown-menu").removeClass("lang-open");

  $("body").removeClass("navi-open");

  $(".level2-wrapper").slideUp(300);

  setTimeout(() => {
    $("li.level1, ul.level1, .show-more").removeClass("open");
  }, 300);
});

$(".dropdown-toggle").on("click", function () {
  $(".dropdown-menu").toggleClass("lang-open");
});

$(".show-more").on("click", function () {
  let isOpen = $(this).hasClass("open");

  $("li.level1, ul.level1, .show-more").removeClass("open");
  $(".level2-wrapper").slideUp(300);

  if (!isOpen) {
    $(this).toggleClass("open");
    $(this).closest("li.level1").toggleClass("open");
    $(this).closest("ul.level1").toggleClass("open");
    $(this).closest("li.level1").children(".level2-wrapper").slideDown(300);
  }
});

if ($(".app-slider").length > 0) {
  document.addEventListener("DOMContentLoaded", function () {
    var appSplide = new Splide(".app-slider", {
      pagination: false,
      arrows: false,
      type: "loop",
      drag: "free",
      focus: "center",
      fixedWidth: "704px",
      gap: "110px",
      breakpoints: {
        768: {
          fixedWidth: "405px",
          gap: "50px",
        },
      },
      autoScroll: {
        speed: 0.5,
        pauseOnHover: false,
        pauseOnFocus: false,
      },
    }).mount(window.splide.Extensions);
  });
}
